



import Page from '../attendance/postWorkdaySetting/personholiday.vue'
export default {
  name: 'postWorkdaySetting',
  components: { Page },
}
